import { useState } from 'react';
import { api, saveSession, type AuthResult } from '../lib/api.ts';
import { ChangePassword } from './ChangePassword.tsx';

/**
 * 登录。账号由管理员创建（自助注册默认开、可在设置里关闭 —— 关闭后本页
 * 不再是入口，开放注册时这里也不放注册表单，注册走接口或管理员建号）。
 *
 * 用初始密码（admin）登录成功但不进系统：mustChangePassword 为 true 时
 * 原地切到改密表单 —— token 已存，改完密无缝进入。
 */
export function Login({ onAuthed }: { onAuthed: (r: AuthResult) => void }) {
  const [pending, setPending] = useState<AuthResult | null>(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (pending !== null) {
    return (
      <ChangePassword
        username={pending.user.username}
        onDone={() => {
          onAuthed(pending);
        }}
      />
    );
  }

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      const r = await api.login(username, password);
      saveSession(r);
      if (r.user.mustChangePassword) {
        setPending(r);
      } else {
        onAuthed(r);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-head">
          <img src="/logo.png" alt="" className="auth-logo" />
          <span className="auth-brand">UP-OA</span>
          <span className="auth-sub">会议与协作，一个入口</span>
        </div>

        <form
          className="auth-mode"
          onSubmit={(e) => void submit(e)}
          style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
        >
          <label className="auth-field">
            <span>用户名</span>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              placeholder="3-32 位字母、数字或下划线"
              required
            />
          </label>
          <label className="auth-field">
            <span>密码</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="至少 8 位"
              required
            />
          </label>

          {error !== null && <div className="auth-error">{error}</div>}

          <button className="auth-submit" disabled={busy}>
            {busy ? '处理中…' : '登录'}
          </button>
        </form>
        <p className="auth-note">遇到账号问题找系统管理员。</p>
      </div>
    </div>
  );
}
